type PaymentPlanFrequency =
  | "weekly"
  | "bi_weekly"
  | "monthly"
  | "one_time"
  | "first_and_fifteenth"
  | "last_business_day_of_the_month"
  | "non_linear"
  | "tax_season";

type PaymentPlanType =
  | "HARDSHIP"
  | "HARDSHIP_EXTENSION"
  | "INTERIM"
  | "NORMAL"
  | "PAYOFF"
  | "TAX_SEASON"
  | "DOWN_PAYMENT"
  | "BUNDLE"
  | "MATRIX_BUNDLE"
  | "MATRIX_DOWN_PAYMENT_BUNDLE"
  | "MATRIX_HARDSHIP_BUNDLE";

type PaymentMethodTypes = "ach" | "card" | "apple_pay" | "google_pay" | "check" | "unknown" | "other";

type PaymentPlanState = "current" | "late" | "revoked" | "active" | "resolved" | "no_plan" | "active_interim";

type PaymentStatus =
  | "Success"
  | "Approved"
  | "Submitted"
  | "Validation"
  | "Pending"
  | "Warning"
  | "Decline"
  | "Failed"
  | "Fraud"
  | "SystemFailure"
  | "Communication"
  | "Error"
  | "Void"
  | "Refund"
  | "Chargeback"
  | "Returned";

const successfulPaymentsStatuses: PaymentStatus[] = ["Success", "Submitted", "Approved"];
const warningPaymentStatuses: PaymentStatus[] = ["Pending"];
const failedPaymentsStatuses: PaymentStatus[] = [
  "Decline",
  "Failed",
  "Error",
  "Fraud",
  "SystemFailure",
  "Void",
  "Refund",
  "Chargeback",
  "Returned",
];

type CardDetails = {
  id: number;
  is_primary: boolean;
  type: PaymentCardType;
  last_4_digits: number;
  wallet_insertion_timestamp?: string;
  expired: boolean;
};

enum PlanRating {
  RED = "RED",
  YELLOW = "YELLOW",
  GREEN = "GREEN",
}

enum PaymentCardType {
  ACH = "ach",
  DINERS = "diners",
  DISCOVER = "discover",
  GENERAL_CARD = "general_card",
  MASTERCARD = "mastercard",
  VISA = "visa",
  APPLE_PAY = "apple_pay",
  GOOGLE_PAY = "google_pay",
}

enum BinCardType {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

export type {PaymentPlanFrequency, PaymentMethodTypes, PaymentPlanState, PaymentStatus, PaymentPlanType, CardDetails};
export {successfulPaymentsStatuses, failedPaymentsStatuses, warningPaymentStatuses, PlanRating, PaymentCardType, BinCardType};
